import { Schema as S } from "effect";
import { PrescriptionActType } from "./list-prescriptions.request";

/**
 * Summary of a single prescription for list display
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const summary: PrescriptionSummary = {
 *   id: "abc123",
 *   actType: "PUBPRESCR",
 *   patientId: "pat456",
 *   medicationName: "Ibuprofen 400mg",
 *   status: "VALID",
 * }
 * ```
 */
export const PrescriptionSummarySchema = S.Struct({
  id: S.String,
  actType: PrescriptionActType,
  patientId: S.String,
  medicationName: S.String,
  status: S.String,
  prescriptionDate: S.optional(S.String),
  content: S.optional(S.String),
  comment: S.optional(S.String),
  employeeName: S.optional(S.String),
});

export type PrescriptionSummary = S.Schema.Type<
  typeof PrescriptionSummarySchema
>;

/**
 * Response schema for listing patient prescriptions
 *
 * @since 1.0.0
 */
export const ListPrescriptionsResponseSchema = S.Struct({
  prescriptions: S.Array(PrescriptionSummarySchema),
  total: S.Number,
});

export type ListPrescriptionsResponse = S.Schema.Type<
  typeof ListPrescriptionsResponseSchema
>;
